import { render, staticRenderFns } from "./EvolucaoFaturamentoVolume.vue?vue&type=template&id=1b8bcf12&scoped=true&"
import script from "./EvolucaoFaturamentoVolume.vue?vue&type=script&lang=js&"
export * from "./EvolucaoFaturamentoVolume.vue?vue&type=script&lang=js&"
import style0 from "./EvolucaoFaturamentoVolume.vue?vue&type=style&index=0&id=1b8bcf12&scoped=true&lang=css&"
import style1 from "./EvolucaoFaturamentoVolume.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bcf12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VRow,VSelect})
